containsEverflowTrackingQueryVars